// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "756e9141",
    "hash": "756e9141",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "756e9141",
    "semverString": null,
    "packageVersion": "1.1.14",
    "BuildTimestamp": "08.01.2025, 12:09"
};
/* tslint:enable */
